<template>
  <div class="languageMenu">
    <drop-down
      :visibility="DropDownVisibility"
      :items="items"
      :active-index="activeLanguageIndex"
      @toggle-dropdown="handleDropDownVisibility"
    >
      <custom-button data-test-id="language-button">
        <img class="kk-language__flag" :src="require(`@/assets/flags/${activeLanguage}.svg`)" />
      </custom-button>
    </drop-down>
  </div>
</template>

<script>
import { I18n } from "aws-amplify";
import CustomButton from "../commons/CustomButton.vue";
import DropDown from "../redZone/content/DropDown.vue";

export default {
  components: {
    CustomButton,
    DropDown,
  },
  props: {
    color: {
      type: String,
      default: "#e2f3f5",
    },
  },
  data() {
    return {
      DropDownVisibility: false,
      items: [
        { code: "en_US", title: "English", func: this.changeLocale, imgClass: "kk-language__flag", id: 0 },
        { code: "de", title: "Deutsch", func: this.changeLocale, imgClass: "kk-language__flag", id: 1 },
      ],
    };
  },
  computed: {
    activeLanguage() {
      return this.$i18n.locale;
    },
    activeLanguageIndex() {
      // Find the index of the active language among items
      return this.items.findIndex((item) => item.code === this.activeLanguage);
    },
  },
  methods: {
    handleDropDownVisibility(visibility) {
      // Update the DropDownVisibility based on the emitted value
      this.DropDownVisibility = visibility;
    },
    changeLocale(item) {
      this.$i18n.locale = item.code;
      I18n.setLanguage(item.code);
      localStorage.setItem("userLanguage", JSON.stringify(item));
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/styles/variables";
.kk-language {
  &__flag {
    width: 2rem;
  }
}
.languageMenu {
  margin-top: 10px;
  position: relative;
}
</style>
